export class PeriodModel {
  id: string;
  name: string;
  language: string;
  from: Date;
  to: Date;

  constructor() {
    this.id = '';
    this.name = '';
  }
}

export class AddPeriodModel {
  id: string;
  name: string;
  language: string;
  from: string;
  to: string;
}
